(function (M) {
  if (!M) return;
  var d = document, intro = d.querySelector('.cl-intro');
  if (!intro) return;
  M.tag('.cl-stage img', 'rise', { d: 0.1, step: 0.15 });
  M.tag('.cl-intro .cl-w > div:last-child > *', 'up', { d: 0.2, step: 0.08 });
  M.all('.cl-band').forEach(function (b) {
    M.tag(M.all('.tx > *', b), 'up', { step: 0.08 });
    M.tag(M.all('.vis > *', b), 'rise', { d: 0.15, step: 0.12 });
  });
  M.tag('.cl-cmp .hd, .cl-cmp .lead', 'up', { step: 0.1 });
  M.tag(M.all('.cl-cmp .r'), 'fade', { d: 0.1, step: 0.05 });
})(window.FJKMotion);
